import React, { Component } from 'react';

require('numeral/locales/en-gb');
const numeral = require('numeral');
const logoMapa = require('./css/img/central_fert/img_mapa.png');

type T_TablaOportEmptyProps = {
  servicio: string
}

export default class TablaOportEmpty extends Component<T_TablaOportEmptyProps> {
  render() {
    const width = this.props.servicio !== 'nutricheck_foliar' ? '451px' : '429px';

    return (
      <div className="CuadroOpt" style={{ margin: '15px auto', width: width, opacity: '0.5' }}>
        <div className="TitleCuadroOpt"><span className="TitleCuadroOpt">DEFICIENCIAS ENCONTRADAS</span></div>
        <div className="ContentOpt"></div>
      </div>
    )
  }
}

type T_TablaOportEstaticProps = {
  servicio: string,
  hect: number,
  showPrecio: boolean,
}

export class TablaOportEstatica extends Component<T_TablaOportEstaticProps> {
  
  render () {
    const { hect, showPrecio } = this.props;
    const prodImage = require('./css/img/tabla_oport/ktionic.png');

    const dosis = 1;
    const recTotal = (hect * dosis) * 7; 

    return (
      <div className="CuadroOpt" style={{ margin: '15px auto', width: '451px', opacity: '1' }}>
        <div className="TitleCuadroOpt">
          <span className="TitleCuadroOpt">COMPLEMENTO DE APLICACION</span>
        </div>
        <div className="ContentOpt">
          <div style={{ width: '451px', display: 'block', margin: '0px 0px 10px 0px' }}>
            <div className="HectOpt" style={{ paddingBottom: '0px' }}>
              <span><p>Superficie Total</p></span>
              <div style={{ backgroundColor: '#ffffff', padding: '0px'/* , height: '150px' */ }}>
                <img src={logoMapa} className="img-mapaUPL" alt="logo_mapa" />
                <span style={{ 
                  position: 'relative', 
                  fontFamily: 'BebasNeue', 
                  fontSize: '30px', 
                  top: '5px' 
                }}> {numeral(hect).format('0,0.0')} </span>
                <span style={{ position: 'relative', fontFamily: 'Raleway', top: '5px' }}>
                  <strong> has</strong>
                </span>
              </div>
            </div>
            <div className="RecomProd" style={{ display: 'block', backgroundColor: '#e2e2e2' }}>
              <span style={{ 
                display: 'inline-block', 
                height: '35px', 
                padding: '5px 0px', 
                fontFamily: 'OpenSans', 
                fontSize: '15px', 
                fontWeight: '600',
                // width: '100%'
              }}>
                <p style={{ margin: '0px' }}>Producto recomendado</p>
              </span>
              <div style={{ display: 'flex', backgroundColor: '#ffffff', height: '102px' }}>
                <div className="recomUnitProd right" style={{ margin: '10px 0px', width: '150px' }}/>
                <div className="recomUnitProd right" style={{ margin: '10px 0px', width: '150px' }}>
                  <div>
                    <img src={prodImage} alt="img1" className="img-producto"/>
                    <p>1 <strong className="recomStyle">l/has</strong></p>
                  </div>
                </div>
                <div className="recomUnitProd " style={{ margin: '10px 0px', width: '150px' }}/>
              </div>
            </div>
            <div className="RecomHect" style={{ display: 'block', backgroundColor: '#e2e2e2'}}>
              <span style={{ 
                display: 'inline-block', 
                height: '35px', 
                padding: '5px 0px', 
                fontFamily: 'OpenSans', 
                fontSize: '15px', 
                fontWeight: '600' 
              }}>
                <p style={{ margin: '0px' }}>Total</p>
              </span>
              <div style={{ display: 'flex', backgroundColor: '#ffffff' }}>
                <div className="recomHectProd right" style={{ margin: '10px 0px', width: '150px' }} />
                <div className="recomHectProd right" style={{ margin: '10px 0px', width: '150px' }}>
                  <div className="recomHectValue">
                    <p>{numeral(Math.ceil(recTotal)).format('0,0')} 
                      <span style={{ fontFamily: 'GillSans', fontWeight: 'bold'}}> l</span>
                    </p>
                  </div>
                </div>
                <div className="recomHectProd" style={{ margin: '10px 0px', width: '150px' }} />
              </div>
            </div>
            {showPrecio &&
              <div className="RecomPrice" style={{ display: 'block' }}>
                <span style={{ height: '40px', display: 'inline-block', padding: '7px 0px', fontFamily: 'OpenSans', fontWeight: '600', fontSize: '14px' }}><p style={{ marginBottom: '10px' }}>Valor Subtotal</p></span>
                <div style={{ backgroundColor: '#ffffff'}}>
                  <div style={{ display: 'flex' }}>
                    <div style={{ margin: '10px auto' }}>
                      <p>$ {numeral(Math.ceil(107.52 * recTotal)).format('0,0')}</p>
                    </div>
                  </div>
                </div>
              </div>
            }
            {showPrecio &&
              <div className="RecomPriceTotal" style={{ display: 'block' }}>
                <span style={{ height: '35px', display: 'inline-block', padding: '7px 0px', fontWeight: '600', fontSize: '14px', fontFamily: 'OpenSans' }}><p style={{ marginBottom: '10px' }}>Valor Total</p></span>
                <div style={{ display: 'flex', backgroundColor: '#ffffff' }}>
                  <div style={{ width: '100%'}}>
                    <div>
                      <p>$ {numeral(Math.ceil(107.52 * recTotal)).format('0,0')}</p>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/TablaOportEmpty.jsx